module.exports = __webpack_public_path__ + "b32b09975ce96636060a8c941c599b57.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/book-covers/book-4.png
// module id = 3404
// module chunks = 0